<template>
  <div class="form-container">
    <div class="form-card">
      <div class="form-header">
        <div class="d-flex align-center" style="gap: 12px;">
          <v-btn icon @click="$router.back()" class="back-btn">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <div class="header-icon">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="9" y1="3" x2="9" y2="21"></line>
            </svg>
          </div>
          <div>
            <h2 class="form-title">Select Vendor & Type</h2>
            <p class="form-subtitle">Configure your vendor and debit note preferences</p>
          </div>
        </div>
      </div>
      
      <div class="form-content">
        <v-row class="form-row">
          <v-col cols="12" lg="4" class="form-col">
            <MultiSelect
              label="Select Vendor *"
              :items="allVendorList"
              itemText="company_title"
              itemValue="id"
              :rules="[(val) => !!val || 'Vendor is Required!']"
              hide-details="auto"
              v-model="formDetails.vendor"
              :error-messages="formErrors.vendor"
              @change="delete formErrors.vendor"
            />
          </v-col>

          <v-col cols="12" lg="4" class="form-col">
            <MultiSelect
              label="Select Category *"
              :items="debitNoteChoice"
              itemText="display_name"
              itemValue="value"
              :rules="[(val) => !!val || 'Type is Required!']"
              hide-details="auto"
              v-model="formDetails.type"
              :error-messages="formErrors.type"
              @change="handleTypeChange"
            />
          </v-col>

          <v-col v-if="formDetails.type && formDetails.type == 'subhire'" cols="12" lg="4" class="form-col">
            <MultiSelect
              label="Select SubHire *"
              :items="subHireCompletedList"
              itemText="sub_hire_id"
              itemValue="id"
              :rules="[(val) => !!val || 'Category is Required!']"
              hide-details="auto"
              v-model="formDetails.category"
              :error-messages="formErrors.category"
              @change="handleCategoryChange"
            />
          </v-col>
          <v-col v-if="formDetails.type && formDetails.type == 'da'" cols="12" lg="4" class="form-col">
            <MultiSelect
              label="Select DA *"
              :items="deliveryAdviceList"
              itemText="da_company_title"
              itemValue="delivery_advice"
              :rules="[(val) => !!val || 'Category is Required!']"
              hide-details="auto"
              v-model="formDetails.category"
              :error-messages="formErrors.category"
              @change="handleCategoryChange"
            />
          </v-col>
        </v-row>

        <div v-if="formDetails.type" class="divider"></div>

        <v-row v-if="formDetails.type" class="grid-row">
          <v-col cols="12" class="grid-col">
            <div class="grid-header">
              <h3 class="grid-title">
                {{ formDetails.type === 'subhire' ? 'SubHire Details' : formDetails.type === 'da' ? 'DA Details' : 'Trip Details' }}
              </h3>
            
            </div>
            <div class="grid-wrapper">
              <AgGridVue 
                style="width: 100%; height: calc(80vh - 240px)" 
                class="ag-theme-alpine custom-grid"
                id="myGrid" 
                :columnDefs="currentHeaders" 
                @grid-ready="onGridReady"
                   :context="context"
                :defaultColDef="defaultColDef" 
                :grid-options="gridOptions"
                :suppressDragLeaveHidesColumns="true" 
                :rowData="gridData"
                rowSelection="multiple"
              />
            </div>
          </v-col>
          <v-col v-if="totalItems > 0" cols="12" class="pagination-col">
            <Pagination 
              :pageNo="pageNo" 
              :totalItems="totalItems" 
              :pageSize="itemsPerPage"
              @itemsPerPageChange="itemsPerPageChanged" 
              @prevPage="prevPage"
              @nextPage="nextPage" 
            />
          </v-col>
        </v-row>
         <FullDebitNoteFormDialog
          v-model="showFullDebitNoteDialog"
          :debitNoteData="debitNoteData"
    
    />
    <PartialDebitNoteFormDialog
          v-model="showPartialDebitNoteDialog"
          :debitNoteData="debitNoteData"
    
    />
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import { AgGridVue } from "ag-grid-vue";
import { debitNoteChoices } from "@/utils/choices";
import DebitNoteButton from "@/components/AgGridComponents/DebitNoteButton.vue";
import FullDebitNoteFormDialog from "@/components/ModuleBased/dialogForms/FullDebitNoteFormDialog.vue";
import PartialDebitNoteFormDialog from "@/components/ModuleBased/dialogForms/PartialDebitNoteFormDialog.vue";
import Pagination from "@/components/General/Pagination.vue";
export default {
  components: {
    AgGridVue,
    MultiSelect,
    DebitNoteButton,
    FullDebitNoteFormDialog,
    PartialDebitNoteFormDialog,
    Pagination
  },
 
  data() {
    return {
      selectedVendor: '',
      allVendorList: [],
      subHireCompletedList: [],
      deliveryAdviceList: [],
      allSubhireList: [],
      formDetails: {},
      debitNoteData:{},
      debitNoteChoice: debitNoteChoices,
      formErrors: {},
      showFullDebitNoteDialog:false,
      showPartialDebitNoteDialog: false,
      selectedDA: '',
      gridData: [],
      totalItems: 0,
      pageNo: 1,
      itemsPerPage: 20,
      
    

      subHireHeaders: [
        {
          headerName: "SubHire ID",
          field: "sub_hire_id",
          sortable: true,
          minWidth: 180,
          pinned: "left",
          tooltipField: "sub_hire_id",
        
        },
        {
          headerName: "Transporter",
          field: "transporter",
          sortable: true,
          minWidth: 150,
          tooltipField: "transporter",
        },
       
        {
          headerName: "Invoice No",
          field: "invoice_no",
          sortable: true,
          minWidth: 140,
        },
        {
          headerName: "Invoice Date",
          field: "invoice_date",
          sortable: true,
          minWidth: 140,
        },
        {
          headerName: "Status",
          field: "status",
          sortable: true,
          minWidth: 140,
          cellRenderer: "StatusChip",
          cellRendererParams: (params) => {
            return {
              status: params.value,
            };
          },
        },
        {
          headerName: "Rate",
          field: "rate",
          sortable: true,
          minWidth: 150,
         
        },
        {
          headerName: "Additional Rate",
          field: "sub_hire_additional_amount",
          sortable: true,
          minWidth: 120,
        },
        {
          headerName: "Total Cost",
          field: "total_cost",
          sortable: true,
          minWidth: 150,
        
        },
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "DebitNoteButton",
          pinned: "right",
          minWidth: 200,
        },
        
      ],

    
      daHeaders: [
       
        {
          headerName: "DA Number",
          field: "da_no",
          sortable: false,
          minWidth: 150,
          tooltipField: "da_no",
        },
        {
          headerName: "Charge Title",
          field: "charge_title",
          sortable: false,
          minWidth: 150,
          tooltipField: "charge_title",
        },
        {
          headerName: "Description",
          field: "description",
          sortable: false,
          minWidth: 170,
          tooltipField: "description",
        },
        {
          headerName: "Rate (with Tax)",
          field: "amount_with_tax",
          sortable: false,
          minWidth: 140,
        },
        {
          headerName: "Amount",
          field: "rate",
          sortable: false,
          minWidth: 150,
         
        },
          {
          headerName: "Tax Amount",
          field: "tax",
          sortable: false,
          minWidth: 150,
         
        },
            {
          headerName: "Tansporter",
          field: "vendor_cost_name",
          sortable: false,
          minWidth: 250,
         
        },
          {
          headerName: "Invoice",
          field: "invoice_no",
          sortable: false,
          minWidth: 150,
         
        },
        {
          headerName: "Invoice Date",
          field: "invoice_date",
          sortable: false,
          minWidth: 150,
         
        },
        {
          headerName: "Status",
          field: "status",
          sortable: false,
          minWidth: 140,
          cellRenderer: "StatusChip",
          cellRendererParams: (params) => {
            return {
              status: params.value,
            };
          },
        },
        
        {
          headerName: "Description",
          field: "description",
          sortable: false,
          minWidth: 250,
          tooltipField: "description",
        },
        {
          headerName: "Remarks",
          field: "remarks",
          sortable: false,
          minWidth: 200,
          tooltipField: "remarks",
        },
         {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "DebitNoteButton",
          pinned: "right",
          minWidth: 200,
        },
      ],

      defaultColDef: {
        resizable: true,
        flex: 1,
        sortable: true,
        initialWidth: 200,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 40,
      },
    };
  },

  computed: {
      context() {
      return { parentComponent: this };
    },
    currentHeaders() {
      if (this.formDetails.type === 'subhire') {
        return this.subHireHeaders;
      } else if (this.formDetails.type === 'da') {
        return this.daHeaders;
      }
      return this.defaultHeaders;
    }
  },

  methods: {
    fullDebitNote(data){
      this.debitNoteData  = data
        this.showFullDebitNoteDialog = true 

    },
     partialDebitNote(data){
      console.log("38738",data)
      this.debitNoteData  = data
        this.showPartialDebitNoteDialog = true 

    },
    handleTypeChange() {
      delete this.formErrors.type;
      delete this.formErrors.category;
      this.formDetails.category = null;
      this.gridData = [];
      this.totalItems = 0;
      this.callApi(this.formDetails.type);
    },

    handleCategoryChange() {
      delete this.formErrors.category;
      this.fetchGridData();
    },

    callApi(type) {
      if (type === 'subhire') {
        this.getSubHireList();
      } else if (type === 'da') {
        this.getDeliveryAdviceChargesList();
      }
    },

    fetchGridData() {
      if (!this.formDetails.category) return;

      if (this.formDetails.type === 'subhire') {
        this.getSubHireDetails();
      } else if (this.formDetails.type === 'da') {
        this.getDaDetails();
      }
    },

    getSubHireDetails() {
      this.$bus.$emit("showLoader", true);
   

      this.$api.subHire
        .getSubHireDetails(this.formDetails.category)
        .then((res) => {
          this.gridData =  [res.data];
          this.totalItems = res.data.count || res.data.length;
          this.$bus.$emit("showLoader", false);
          this.resizeGrid();
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    getDaDetails() {
      this.$bus.$emit("showLoader", true);
      const params = {
        delivery_advice: this.formDetails.category,
        const_vendor: this.formDetails.vendor,
        da_charge_type:"Cost"
     
      };

   
      this.$api.deliveryAdviceCharge
        .getDeliveryAdviceCostChargesList(params)
        .then((res) => {
          this.gridData = res.data;
          this.totalItems = res.data.count || res.data.length;
          this.$bus.$emit("showLoader", false);
          this.resizeGrid();
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    getSubHireList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        status: "Completed",
        limit: "all",
        company: this.formDetails.vendor,
      };
    
      this.$api.subHire
        .getSubHireDebitNoteList(params)
        .then((res) => {
          this.subHireCompletedList = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
     getDeliveryAdviceChargesList() {
      this.$api.deliveryAdviceCharge
        .getDeliveryAdviceCostChargesList({
         cost_vendor: this.formDetails.vendor,
          is_debit_note_created:false,
          limit: "all",
        })
        .then((res) => {
          this.deliveryAdviceList = res.data;
          
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't Fetch delivery cost charge list!",
            color: "error",
          });
          this.formErrors = err.data;
        });
    },

   

    getDaList() {
      this.$bus.$emit("showLoader", true);
      const params = {
        vendor: this.formDetails.vendor,
        limit: "all",
      };

      // Replace with your actual API endpoint for DA list
      this.$api.debitNote
        .getDaList(params)
        .then((res) => {
          this.allSubhireList = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    getVendorList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        company_type: "Transporter",
        limit: "all",
        ...params,
      };
      this.$api.company
        .getCompanySelectList(params)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.allVendorList = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },

    resizeGrid() {
      if (this.gridApi) {
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 100);
      }
    },

    itemsPerPageChanged(value) {
      this.itemsPerPage = value;
      this.pageNo = 1;
      this.fetchGridData();
    },

    prevPage() {
      if (this.pageNo > 1) {
        this.pageNo--;
        this.fetchGridData();
      }
    },

    nextPage() {
      this.pageNo++;
      this.fetchGridData();
    },
  },

  watch: {
    'formDetails.type': function(newVal, oldVal) {
      if (newVal !== oldVal && this.gridApi) {
        this.gridApi.setColumnDefs(this.currentHeaders);
        this.resizeGrid();
      }
    }
  },

  mounted() {
    this.getVendorList();
  }
};
</script>

<style scoped>
.form-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  padding: 24px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.form-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  max-width: 1600px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.form-header {
  display: flex;
  align-items: center;
  padding: 24px 32px;
  background: linear-gradient(135deg, #ec960c 0%, #de6209 100%);
  gap: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.back-btn {
  color: white !important;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.icon {
  width: 24px;
  height: 24px;
  color: white;
}

.form-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: white;
  letter-spacing: -0.5px;
}

.form-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 400;
}

.form-content {
  padding: 32px;
}

.form-row {
  margin: 0 -12px;
}

.form-col {
  padding: 0 12px 24px 12px;
}

.divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #e5e7eb, transparent);
  margin: 8px 0 32px 0;
}

.grid-row {
  margin: 0;
}

.grid-col {
  padding: 0;
}

.grid-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.grid-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.grid-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.item-count {
  font-size: 13px;
  color: #80776b;
  font-weight: 500;
  padding: 6px 12px;
  background: #f3f4f6;
  border-radius: 6px;
}

.grid-wrapper {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.pagination-col {
  padding-top: 20px;
}

/* AG Grid Custom Styling */
:deep(.custom-grid) {
  border: none;
  font-family: inherit;
}

:deep(.custom-grid .ag-header) {
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
  font-weight: 600;
}

:deep(.custom-grid .ag-header-cell) {
  padding: 12px 16px;
}

:deep(.custom-grid .ag-cell) {
  padding: 0 16px;
  display: flex;
  align-items: center;
}

:deep(.custom-grid .ag-row) {
  border-bottom: 1px solid #f3f4f6;
}

:deep(.custom-grid .ag-row:hover) {
  background: #f9fafb;
}

:deep(.custom-grid .ag-row-selected) {
  background: #eff6ff !important;
}

@media (max-width: 1024px) {
  .form-row {
    margin: 0;
  }
  
  .form-col {
    padding: 0 0 24px 0;
  }
}

@media (max-width: 768px) {
  .form-container {
    padding: 16px;
  }

  .form-header {
    padding: 20px 24px;
  }

  .header-icon {
    width: 40px;
    height: 40px;
  }

  .form-title {
    font-size: 18px;
  }

  .form-subtitle {
    font-size: 13px;
  }

  .form-content {
    padding: 24px 20px;
  }

  .grid-wrapper {
    border-radius: 8px;
  }
}
</style>